var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconAlertHexagon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 16.0002V24.0002M24 32.0002H24.02M6 15.8831V32.1173C6 32.8026 6 33.1452 6.10097 33.4508C6.19029 33.7212 6.33632 33.9693 6.52927 34.1787C6.74737 34.4154 7.0469 34.5818 7.64594 34.9146L22.4459 43.1368C23.0132 43.4519 23.2968 43.6095 23.5971 43.6712C23.8629 43.7259 24.1371 43.7259 24.4029 43.6712C24.7032 43.6095 24.9868 43.4519 25.5541 43.1368L40.3541 34.9146C40.9531 34.5818 41.2526 34.4154 41.4707 34.1787C41.6637 33.9693 41.8097 33.7212 41.899 33.4508C42 33.1452 42 32.8026 42 32.1173V15.8831C42 15.1978 42 14.8551 41.899 14.5495C41.8097 14.2792 41.6637 14.031 41.4707 13.8216C41.2526 13.585 40.9531 13.4186 40.3541 13.0858L25.5541 4.86353C24.9868 4.54842 24.7032 4.39086 24.4029 4.32909C24.1371 4.27442 23.8629 4.27442 23.5971 4.32909C23.2968 4.39086 23.0132 4.54842 22.4459 4.86353L7.64594 13.0858C7.04689 13.4186 6.74737 13.585 6.52927 13.8216C6.33632 14.031 6.19029 14.2792 6.10097 14.5495C6 14.8551 6 15.1978 6 15.8831Z",
    stroke: "#EA1212",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAlertHexagon);
export default __webpack_public_path__ + "static/media/IconAlertHexagon.e9ad1b93fcae412a4d40063daf0b5c47.svg";
export { ForwardRef as ReactComponent };